export default __webpack_public_path__ + "static/media/onlymurdersinthebuilding.603e90fb.jpg";